export function normalizePhoneHref(rawPhone) {
  const input = String(rawPhone || '').trim();
  const cleaned = input.replace(/[^\d+]/g, '');

  if (!cleaned) return '';
  if (cleaned.startsWith('+')) return cleaned;

  const digits = cleaned.replace(/\D/g, '');
  if (!digits) return '';

  if (digits.startsWith('966')) return `+${digits}`;
  if (digits.startsWith('0') && digits.length >= 10) return `+966${digits.slice(1)}`;
  if (digits.startsWith('5') && digits.length === 9) return `+966${digits}`;

  return `+${digits}`;
}

export function formatSaudiLocalPhone(rawPhone) {
  const digits = String(rawPhone || '').replace(/\D/g, '');
  if (!digits) return '';

  let local = digits;

  if (digits.startsWith('966') && digits.length >= 12) {
    local = `0${digits.slice(3, 12)}`;
  } else if (digits.startsWith('5') && digits.length === 9) {
    local = `0${digits}`;
  }

  if (local.startsWith('05') && local.length === 10) {
    return `${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6)}`;
  }

  return rawPhone;
}
